import { useLocalizationContext } from '@va/localization';
import { fontWeights, Paragraph } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import { addNumberSeparator } from '@va/util/helpers';
import classNames from 'classnames';
import { ReactNode } from 'react';

type ConsumedTouchpointRowProps = {
  label?: string;
  icon?: ReactNode;
  count?: number;
  limit?: number;
  rightIcon?: JSX.Element;
  labelTooltip?: string;
  hidden?: boolean;
};

export const ConsumedTouchpointRow = ({
  label,
  icon,
  count,
  rightIcon,
  labelTooltip,
  hidden = false,
  limit,
}: ConsumedTouchpointRowProps) => {
  const { locale, translate } = useLocalizationContext();

  if (hidden) return null;

  return (
    <div className='flex items-center justify-between'>
      <div className='flex flex-row items-center gap-[0.5625rem]'>
        {icon && <div className='max-w-14'>{icon}</div>}
        <TooltipWrapper content={labelTooltip} disabled={!labelTooltip} arrowColor={'#000'}>
          <Paragraph
            className={classNames('opacity-90', { 'underline-dashed': !!labelTooltip })}
            weight={fontWeights.medium}
          >
            {label}
          </Paragraph>
        </TooltipWrapper>
      </div>
      <div className='flex items-center gap-3'>
        {limit === undefined && count !== undefined && (
          <Paragraph colorClassName='text-white' weight={fontWeights.medium}>
            {addNumberSeparator(count, locale)}
          </Paragraph>
        )}
        {count !== undefined && limit !== undefined && (
          <Paragraph colorClassName='text-white' weight={fontWeights.medium}>
            {translate('feature.counter.counting', {
              behaviourCount: addNumberSeparator(count, locale),
              featureLimit: limit === -1 ? '∞' : addNumberSeparator(limit, locale),
            })}
          </Paragraph>
        )}
        {rightIcon}
      </div>
    </div>
  );
};
